import {
  setAppLanguage,
  setAvailableCountries,
  setBrowser,
  setIPCountry,
  setIsInitSuccess,
  setMessage,
  setStaticURL,
} from '../../store/reducers/appSlice';
import {
  updateProfile,
  setUserCompanyDetails,
  setUserCompanySettings,
  updateMerchant,
  updateOnboardingStage,
  setAiOnboardingInprogress,
  setIsAiOnboardingCompleted,
  setTaraSubscriptionDetails,
  setTaraTrialDetails,
} from '../../store/reducers/userSlice';
import store from '../../store/store';

import { Country } from '../../store/reducers/appSlice';
import { setAppThemeType, setIsWhiteLabel } from '../../store/reducers/uiSlice';
import { stepsAndStagesMap } from '../constants/steps_stages_map';
import { tokenRevokeAtLogOutUser } from './logout-user';
import { APP_ENV, INTERCOM_ENABLED_ENVS } from '../constants/central-api';
import { t } from 'i18next';
import isNotEmptyString from '../helper-functions/isNotEmptyString';
import localStorageHardReset from '../helper-functions/localStorageHardReset';
import onboarding_state_updates from './onboarding-state-updates';
import getCurrencySymbol from '../helper-functions/getCurrencySymbol';

/**
 * Update the state using the data received from the /init response
 * @param { any } initResponseData  The data sent by a successful init response
 */
export function initResponseStateUpdate(initResponseData: any) {
  const { user_data, app_data, merchant, shop, seller, subscription } =
    initResponseData;

  const { countries, static_base_url } = app_data;

  const activeShopSlug = store.getState().user?.profile?.active_shop_slug;

  const isAiOnboardingInProgress =
    store.getState().user?.ai_onboarding?.is_ai_onboarding_inprogress ?? false;

  const logoutHandler = () => {
    tokenRevokeAtLogOutUser();
    if (INTERCOM_ENABLED_ENVS.includes(APP_ENV)) {
      // @ts-ignore:next-line
      window.Intercom && window.Intercom('shutdown'); //shutdown intercom
    }

    localStorageHardReset();
  };

  //* TARA subscription state update
  if (subscription && Array.isArray(subscription) && subscription?.length > 0) {
    const filteredTaraSubscriptions = subscription.filter(
      (item: any) =>
        item.subscription_type_slug === 'tara-ai-services' &&
        // item.is_active === 1 &&
        item.status === 'success' &&
        item.is_trial === false
    );

    const currentSubscription =
      filteredTaraSubscriptions.length > 0
        ? filteredTaraSubscriptions[0]
        : null;

    if (currentSubscription) {
      const savingDetails = {
        ...currentSubscription,
        currentSubscriptionStatus: 'active',
      };
      store.dispatch(setTaraSubscriptionDetails(savingDetails));
    } else {
      store.dispatch(
        setTaraSubscriptionDetails({ currentSubscriptionStatus: 'none' })
      );
    }
  } else {
    store.dispatch(
      setTaraSubscriptionDetails({ currentSubscriptionStatus: 'none' })
    );
  }

  if (shop && Array.isArray(shop)) {
    if (shop.length === 0) {
      // Init returned empty shop array - clear all_shops (e.g. user deleted all)
      store.dispatch(
        updateProfile({
          active_shop_slug: '',
          all_shops: [],
        })
      );
    } else {
      const allActiveShops = shop.filter((shop: any) => shop.is_active === 1); //? Filter to only include active shops

      const activeShop =
        activeShopSlug && isNotEmptyString(activeShopSlug)
          ? allActiveShops.find((shop: any) => shop.slug === activeShopSlug) ||
            allActiveShops[0]
          : allActiveShops[0];

      store.dispatch(
        updateProfile({
          active_shop_slug: activeShop?.slug,
          all_shops: allActiveShops.map((shop: any) => ({
            id: shop.id,
            slug: shop.slug,
            name: shop.name,
            webshop_url: shop.settings?.general?.webshop_url ?? '',
          })),
        })
      );

      const {
        id,
        currency,
        name,
        slug,
        settings,
        location,
        is_active,
        initial,
        stats,
      } = activeShop;
      store.dispatch(
        setUserCompanyDetails({
          name,
          currency,
          currency_symbol: getCurrencySymbol(currency),
          shop_id: id?.toString(),
          shop_slug: slug,
          location: location ? location : '',
          is_active: is_active ? is_active : false,
          initial: initial ? initial : '',
          webshop_url: settings?.general?.webshop_url ?? '',
        })
      );

      onboarding_state_updates(id, stats);
      store.dispatch(setUserCompanySettings(settings));

      //* Added below for the MCP Launch
      //* Shop is available which means Company setup is completed therefore setting onboarding in progress to false
      // store.dispatch(setAiOnboardingInprogress(true));

      //* If onboarding is not in progress, set onboarding to completed
      // if (!isAiOnboardingInProgress) {
      //   store.dispatch(setIsAiOnboardingCompleted(false));
      // }
    }
  }

  if (static_base_url) {
    store.dispatch(setStaticURL(static_base_url));

    //Remove this when the API is ready
    store.dispatch(setAppThemeType('2'));
  }

  if (countries) {
    const countriesArray: Country[] = [];

    countries.map((countryObject: any) => {
      const countryCode = Object.keys(countryObject)[0];
      const countryInfo = countryObject[countryCode];
      countriesArray.push({
        countryCode,
        name: countryInfo.name,
        dialCode: countryInfo.dial_code,
        flag: countryInfo.flag,
      });
    });

    store.dispatch(setAvailableCountries({ countries: countriesArray }));
    store.dispatch(setIPCountry(user_data?.device_country?.countryCode));
  }

  //getting browser language
  const browserLanguage = isNotEmptyString(user_data?.browser_language)
    ? user_data?.browser_language?.split('_')[0]
    : 'en';
  store.dispatch(setAppLanguage(browserLanguage));
  store.dispatch(
    updateProfile({
      language: browserLanguage,
    })
  );

  //getting browser name
  store.dispatch(setBrowser(user_data?.browser_name));

  if (seller?.seller_id) {
    const userRole =
      seller?.roles && Array.isArray(seller?.roles)
        ? seller.roles.find((role: any) => role.name === 'agency')
          ? 'agency'
          : seller.roles[0]?.name || 'seller'
        : 'seller';

    store.dispatch(
      updateProfile({
        seller_id: seller?.seller_id?.toString() ?? '',
        user_id: seller?.user_id?.toString() ?? '',
        role: userRole,
        first_name: seller?.first_name ?? '',
        last_name: seller?.last_name ?? '',
        country_code: seller?.country_code ?? '',
        phone: seller?.contact ?? '',
        email: seller?.email ?? '',
        language: isNotEmptyString(seller?.language)
          ? seller?.language?.split('_')[0]
          : browserLanguage,
        custom_openai_key:
          !seller?.custom_openai_key || seller?.custom_openai_key === null
            ? ''
            : seller?.custom_openai_key,
      })
    );

    if (userRole === 'agency') {
      //* Trigger intercom event when the user account is an agency
      // @ts-ignore:next-line
      if (INTERCOM_ENABLED_ENVS.includes(APP_ENV) && window.Intercom) {
        console.log('INTERCOM Event Triggered: is-agency');
        // @ts-ignore:next-line
        window.Intercom('trackEvent', 'is-agency');
      }
    }

    //* TARA trial state update
    if (seller?.is_trial) {
      store.dispatch(
        setTaraTrialDetails({
          is_trial: true,
          trial_available_days: seller?.trial_available_days,
        })
      );
    } else {
      store.dispatch(
        setTaraTrialDetails({
          is_trial: false,
          trial_available_days: undefined,
        })
      );
    }
  }

  if (merchant?.id) {
    store.dispatch(updateMerchant(merchant));

    if (merchant?.is_white_label) {
      store.dispatch(setIsWhiteLabel(true));
    }
  }

  //* If the seller has no shop, redirect to onboarding
  if (
    seller?.seller_id &&
    (!shop || (shop && Array.isArray(shop) && shop?.length <= 0))
  ) {
    const current_step = 'step_1';

    if (seller?.seller_id) {
      store.dispatch(
        updateOnboardingStage(stepsAndStagesMap[current_step].name)
      );
      store.dispatch(setAiOnboardingInprogress(true));
    }
  }

  if (seller === null) {
    store.dispatch(setIsInitSuccess(false));
    logoutHandler();
    store.dispatch(
      setMessage({
        message: t('SomethingWentWrong-msg'),
        messageType: 'error',
      })
    );
  }
}
